export enum ClientReportCategories {
    HistoricDataReportExtracts = "Data Report Extracts",
    RegulatoryReports = "Regulatory Reports",
};